/* Interactive shoppable-ingredients demo.
   Pairs <rk-b-shop-ingredients> with <rk-b-cart-panel> inside a
   [data-shop-demo] scope. ATC buttons toggle the matching cart line and
   recompute the subtotal. State is per-scope, so the hero demo and the
   shoppable-section demo run independently. */
(function () {
  'use strict';

  function fmt(n) {
    return '$' + n.toFixed(2);
  }

  function init(scope) {
    var buttons = scope.querySelectorAll('.rk-shop__atc');
    var list = scope.querySelector('[data-cart-list]');
    var totalEl = scope.querySelector('[data-cart-total]');
    var countEl = scope.querySelector('[data-cart-count]');
    var emptyEl = scope.querySelector('[data-cart-empty]');
    var addAllBtn = scope.querySelector('[data-shop-add-all]');
    if (!buttons.length || !list || !totalEl || !countEl) return;

    function recompute() {
      var visibleLines = list.querySelectorAll('.rk-cart-panel__line:not(.is-out)');
      var total = 0;
      visibleLines.forEach(function (line) {
        var btn = scope.querySelector(
          '.rk-shop__atc[data-product-id="' + line.dataset.cartLineFor + '"]'
        );
        if (btn) total += parseFloat(btn.dataset.productPrice) || 0;
      });
      totalEl.textContent = fmt(total);
      countEl.textContent = visibleLines.length;
      if (emptyEl) emptyEl.hidden = visibleLines.length > 0;
      list.hidden = false;

      if (addAllBtn) {
        var allAdded = Array.prototype.every.call(buttons, function (b) {
          return b.classList.contains('is-added');
        });
        addAllBtn.classList.toggle('is-all-added', allAdded);
        addAllBtn.querySelector('.rk-shop__add-all-text') &&
          (addAllBtn.querySelector('.rk-shop__add-all-text').textContent =
            allAdded ? 'All ingredients added' : 'Add All To Cart');
      }
    }

    function setButtonState(btn, added) {
      btn.classList.toggle('is-added', added);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      var text = btn.querySelector('.rk-shop__atc-text');
      if (text) text.textContent = added ? 'Added' : 'Add To Cart';
    }

    function toggle(btn) {
      var id = btn.dataset.productId;
      var line = list.querySelector('[data-cart-line-for="' + id + '"]');
      if (!line) return;
      var add = !btn.classList.contains('is-added');
      setButtonState(btn, add);
      line.classList.toggle('is-out', !add);
      recompute();
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggle(btn);
      });
    });

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var allAdded = Array.prototype.every.call(buttons, function (b) {
          return b.classList.contains('is-added');
        });
        buttons.forEach(function (btn) {
          var id = btn.dataset.productId;
          var line = list.querySelector('[data-cart-line-for="' + id + '"]');
          if (!line) return;
          setButtonState(btn, !allAdded);
          line.classList.toggle('is-out', allAdded);
        });
        recompute();
      });
    }

    recompute();
  }

  function boot() {
    document.querySelectorAll('[data-shop-demo]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
